import { Link } from "react-router-dom";
import { useSiteSettings } from "../../../contexts/SiteSettingsContext";

export default function SiteFooter() {
  const { settings } = useSiteSettings();
  return (
    <footer className="w-full border-t border-pink-100 mt-8" style={{ background: "linear-gradient(135deg, #fae8f2 0%, #ffcde9 100%)" }}>
      <div className="max-w-5xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <a href={settings.headerUrl} className="text-pink-800 font-bold text-lg" style={{ fontFamily: "'Georgia', serif" }}>
          {settings.footerTitle}
        </a>
        <p className="text-xs text-pink-500">{settings.footerCopyright}</p>
        {settings.footerAdminLink && (
          <Link to="/admin" className="text-xs text-pink-400 hover:text-pink-700 transition-colors cursor-pointer">
            管理パネル
          </Link>
        )}
      </div>
    </footer>
  );
}
